const dynamicLabelStyle = { fill: 'blue', fontWeight: 700 };

export const initialNodes = [
	{
		id: '1',
		type: 'input',
		data: { label: 'Input Layer (1x3x224x224)' },
		position: { x: 250, y: 0 },
		sourcePosition: 'bottom',
	},
	{
		id: '2',
		type: 'Convolution',
		data: {
			label: 'Conv Layer 1',
			parameters: { kernel_size: 11, stride: 4, filters: 96 },
		},
		position: { x: 250, y: 100 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '3',
		type: 'ReLU',
		data: { label: 'ReLU 1' },
		position: { x: 250, y: 200 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '4',
		type: 'Pooling',
		data: { label: 'Max Pooling 1', parameters: { pool_size: 3, stride: 2 } },
		position: { x: 250, y: 300 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '5',
		type: 'Convolution',
		data: {
			label: 'Conv Layer 2',
			parameters: { kernel_size: 5, stride: 1, filters: 256 },
		},
		position: { x: 250, y: 400 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '6',
		type: 'ReLU',
		data: { label: 'ReLU 2' },
		position: { x: 250, y: 500 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '7',
		type: 'Pooling',
		data: { label: 'Max Pooling 2', parameters: { pool_size: 3, stride: 2 } },
		position: { x: 250, y: 600 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '8',
		type: 'Convolution',
		data: {
			label: 'Conv Layer 3',
			parameters: { kernel_size: 3, stride: 1, filters: 384 },
		},
		position: { x: 250, y: 700 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '9',
		type: 'ReLU',
		data: { label: 'ReLU 3' },
		position: { x: 250, y: 800 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '10',
		type: 'Convolution',
		data: {
			label: 'Conv Layer 4',
			parameters: { kernel_size: 3, stride: 1, filters: 384 },
		},
		position: { x: 250, y: 900 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '11',
		type: 'ReLU',
		data: { label: 'ReLU 4' },
		position: { x: 250, y: 1000 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '12',
		type: 'Convolution',
		data: {
			label: 'Conv Layer 5',
			parameters: { kernel_size: 3, stride: 1, filters: 256 },
		},
		position: { x: 250, y: 1100 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '13',
		type: 'ReLU',
		data: { label: 'ReLU 5' },
		position: { x: 250, y: 1200 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '14',
		type: 'Pooling',
		data: { label: 'Max Pooling 3', parameters: { pool_size: 3, stride: 2 } },
		position: { x: 250, y: 1300 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '15',
		type: 'FullyConnected',
		data: { label: 'Fully Connected Layer 1', parameters: { units: 4096 } },
		position: { x: 250, y: 1400 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '16',
		type: 'ReLU',
		data: { label: 'ReLU 6' },
		position: { x: 250, y: 1500 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '17',
		type: 'Dropout',
		data: { label: 'Dropout 1', parameters: { rate: 0.5 } },
		position: { x: 250, y: 1600 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '18',
		type: 'FullyConnected',
		data: { label: 'Fully Connected Layer 2', parameters: { units: 4096 } },
		position: { x: 250, y: 1700 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '19',
		type: 'ReLU',
		data: { label: 'ReLU 7' },
		position: { x: 250, y: 1800 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '20',
		type: 'Dropout',
		data: { label: 'Dropout 2', parameters: { rate: 0.5 } },
		position: { x: 250, y: 1900 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '21',
		type: 'FullyConnected',
		data: { label: 'Fully Connected Layer 3', parameters: { units: 1000 } },
		position: { x: 250, y: 2000 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '22',
		type: 'Softmax',
		data: { label: 'Softmax' },
		position: { x: 250, y: 2100 },
		sourcePosition: 'bottom',
		targetPosition: 'top',
	},
	{
		id: '23',
		type: 'output',
		data: { label: 'Output Layer (1x1000x1x1)' },
		position: { x: 250, y: 2200 },
		sourcePosition: 'top',
		targetPosition: 'bottom',
	},
];

export const initialEdges = [
	{
		id: 'e1-2',
		source: '1',
		target: '2',
		animated: true,
		label: 'Edge e1-2',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e2-3',
		source: '2',
		target: '3',
		animated: true,
		label: 'Edge e2-3',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e3-4',
		source: '3',
		target: '4',
		animated: true,
		label: 'Edge e3-4',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e4-5',
		source: '4',
		target: '5',
		animated: true,
		label: 'Edge e4-5',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e5-6',
		source: '5',
		target: '6',
		animated: true,
		label: 'Edge e5-6',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e6-7',
		source: '6',
		target: '7',
		animated: true,
		label: 'Edge e6-7',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e7-8',
		source: '7',
		target: '8',
		animated: true,
		label: 'Edge e7-8',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e8-9',
		source: '8',
		target: '9',
		animated: true,
		label: 'Edge e8-9',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e9-10',
		source: '9',
		target: '10',
		animated: true,
		label: 'Edge e9-10',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e10-11',
		source: '10',
		target: '11',
		animated: true,
		label: 'Edge e10-11',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e11-12',
		source: '11',
		target: '12',
		animated: true,
		label: 'Edge e11-12',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e12-13',
		source: '12',
		target: '13',
		animated: true,
		label: 'Edge e12-13',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e13-14',
		source: '13',
		target: '14',
		animated: true,
		label: 'Edge e13-14',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e14-15',
		source: '14',
		target: '15',
		animated: true,
		label: 'Edge e14-15',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e15-16',
		source: '15',
		target: '16',
		animated: true,
		label: 'Edge e15-16',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e16-17',
		source: '16',
		target: '17',
		animated: true,
		label: 'Edge e16-17',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e17-18',
		source: '17',
		target: '18',
		animated: true,
		label: 'Edge e17-18',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e18-19',
		source: '18',
		target: '19',
		animated: true,
		label: 'Edge e18-19',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e19-20',
		source: '19',
		target: '20',
		animated: true,
		label: 'Edge e19-20',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e20-21',
		source: '20',
		target: '21',
		animated: true,
		label: 'Edge e20-21',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e21-22',
		source: '21',
		target: '22',
		animated: true,
		label: 'Edge e21-22',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e22-23',
		source: '22',
		target: '23',
		animated: true,
		label: 'Edge e22-23',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e23-24',
		source: '23',
		target: '24',
		animated: true,
		label: 'Edge e23-24',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e24-25',
		source: '24',
		target: '25',
		animated: true,
		label: 'Edge e24-25',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e25-26',
		source: '25',
		target: '26',
		animated: true,
		label: 'Edge e25-26',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e26-27',
		source: '26',
		target: '27',
		animated: true,
		label: 'Edge e26-27',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e27-28',
		source: '27',
		target: '28',
		animated: true,
		label: 'Edge e27-28',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e28-29',
		source: '28',
		target: '29',
		animated: true,
		label: 'Edge e28-29',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e29-30',
		source: '29',
		target: '30',
		animated: true,
		label: 'Edge e29-30',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
	{
		id: 'e30-1',
		source: '30',
		target: '1',
		animated: true,
		label: 'Edge e30-1',
		type: 'straight',
		labelStyle: dynamicLabelStyle,
	},
];
